// src/utils/modalHelper.js
export function openContactModal() {
    const modalEl = document.getElementById('contactModal');
    if (modalEl) {
      import('bootstrap').then(({ Modal }) => {
        const contactModal = new Modal(modalEl);
        contactModal.show();
      });
    }
  }

export function openPricingModal(options = {}) {
    const modalEl = document.getElementById('pricingModal');
    if (modalEl) {
      // Dispatch custom event with pricing data
      const event = new CustomEvent('pricing-modal-open', {
        detail: {
          title: options.title || 'Planes y Precios',
          description: options.description || 'Todo lo que necesitas para transformar la experiencia de tus clientes, en un solo lugar.',
          price: options.price || '$600 MXN'
        }
      });
      window.dispatchEvent(event);

      import('bootstrap').then(({ Modal }) => {
        const pricingModal = new Modal(modalEl);
        pricingModal.show();
      });
    }
  }